import { Separator, cn } from "@weblinkpong/ui";
import { SidebarTrigger } from "../ui/sidebar";
import { useEffect, useState, type HTMLAttributes } from "react";

type HeaderProps = HTMLAttributes<HTMLElement> & { fixed?: boolean };

export function Header({
  className,
  fixed = true,
  children,
  ...props
}: HeaderProps) {
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const onScroll = () => setOffset(document.documentElement.scrollTop);
    document.addEventListener("scroll", onScroll, { passive: true });
    return () => document.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <header
      className={cn(
        "z-50 h-16",
        fixed && "sticky top-0 w-[inherit]",
        offset > 10 && fixed ? "shadow-sm" : "shadow-none",
        className,
      )}
      {...props}
    >
      <div
        className={cn(
          "relative flex h-full items-center gap-3 p-4 sm:gap-4",
          offset > 10 &&
            fixed &&
            "after:absolute after:inset-0 after:-z-10 after:bg-background/80 after:backdrop-blur-lg",
        )}
      >
        <SidebarTrigger variant="outline" className="max-md:scale-110" />
        <Separator orientation="vertical" className="h-6" />
        {children}
      </div>
    </header>
  );
}
